import Scriba from 'react-scriba';

export class DataDemande {

    static _chargementDemandes = (filtres, sortedColumn, isSortedDescending, facteurNbreEnregistrement, pageIndex) => {
        const objet = { filtres, sortedColumn, isSortedDescending, facteurNbreEnregistrement, pageIndex };
        const url = "api/Liste/ListeDesDemandes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementDemandesEtRelances = (filtres, sortedColumn, isSortedDescending, facteurNbreEnregistrement, pageIndex) => {
        const objet = { filtres, sortedColumn, isSortedDescending, facteurNbreEnregistrement, pageIndex };
        const url = "api/Liste/ListeDesDemandesEtRelances";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementDemande = (idDemande) => {
        const objet = { idDemande };
        const url = "api/Fiche/FicheDemande";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementDemande = (demande, destinataires) => {
        const url = "api/MAJDonnees/EnregistrementDemande";
        const paramPost = Scriba.fetch().createParameterPost({ demande, destinataires });
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionDemande = (idDemande) => {
        const objet = { idDemande };
        const url = "api/MAJDonnees/SuppressionDemande";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onPublipostageDemande = (idDemande, rowGuid) => {
        const url = "api/Download/PubliposterDemande";
        const paramPost = Scriba.fetch().createParameterPost({ idDemande, rowGuid });
        return fetch(url, paramPost).then(response => response.json());
    };

}
